import { refreshCurrentDate } from "../../cpcoc/currentDate";
import { months } from "../../cpcoc/months";
import { guestSpeakers } from "../data/guest-speaker-events";
import { createSlide } from "../slidesOps/createSlide";
export function slideGuestSpeakers() {
    const now = refreshCurrentDate();
    const delay = 1000;
    const waitToShow = 1000 * 60 * 60 * 24 * 14; // 2 weeks, 14 days
    for (let i = 0, l = guestSpeakers.length; i < l; i++) {
        const speaker = guestSpeakers[i];
        const date = new Date(speaker.date + " 23:59:00");
        const isItToday = `${now.getMonth() + 1} ${now.getDate()}, ${now.getFullYear()}` ===
            `${date.getMonth() + 1} ${date.getDate()}, ${date.getFullYear()}`;
        const formattedDate = `${months[date.getMonth()]} ${date.getDate()}`;
        if (now.valueOf() >= new Date(speaker.date).valueOf() - waitToShow &&
            now <= date) {
            const html = `
                <div style="text-align: left; margin: 0 50px;" class="fragment" data-autoslide="${delay / 4}" data-fragment-index="0">
                    <div style="margin-left: 316px;">
                        <h2 class="fragment fade-down" data-autoslide="${delay / 4}" data-fragment-index="${isItToday ? 5 : 1}" style="font-weight: 300;">
                            ${isItToday
                ? "Welcome to Cedar Park!"
                : "Joining us " + formattedDate}
                        </h2>
                        <hr class="fragment fade-right" data-autoslide="${delay * 2}" data-fragment-index="${isItToday ? 6 : 2}" />
                    </div>
                    <div style="display: flex;">
                        <img src="${speaker.image}" alt="Photo of ${speaker.name}" style="width: 250px; height: 250px; border-radius: 50%; border: 8px solid #fff;margin: 0;display: block; margin-right: 50px;" class="fragment fade-up" data-autoslide="${delay / 4}" data-fragment-index="3" />
                        <div>
                            <h3 class="fragment fade-right" data-autoslide="${delay * 2}" data-fragment-index="4" style="font-size:125px; margin: 0;line-height: 1; margin-bottom: 16px;">
                                ${speaker.name}
                            </h3>
                            <p class="text-color text-color--secondary fragment fade-left" data-autoslide="${delay * 2}" data-fragment-index="4" style="margin: 0;font-weight: 300;">
                                ${speaker.from}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="fragment" data-autoslide="25000" data-fragment-index="7"></div>
            `;
            createSlide({
                autoslide: 150,
                center: true,
                html: html,
                background: { color: "#000" },
            }, `guestspeaker-${speaker.name.toLowerCase().replace(/ /g, "-")}`);
        }
    }
}
